export default __webpack_public_path__ + "assets/images/a4236f57fbfc83d0cbae4b3a8bfbd051.svg";